import { NewmembersComponent } from './newmembers/newmembers.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NotificationService } from '../notification.service';
import { PatientService } from '../shared/patient.service';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.css']
})
export class MembersComponent implements OnInit {
  public animal: 'cate';
  name: 'adnan';
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  listData: MatTableDataSource<any>;
  displayedColumns: string[] = ['membercode', 'membername', 'age', 'gender','phoneno','patientno','email','actions'];

  constructor(public patientservice: PatientService,
    public dialog : MatDialog) { }

  ngOnInit(): void {
    this.loadmemberlist();    
  }

  get id() {
    return localStorage.getItem('userID')
  }

  loadmemberlist()
  {
    console.log(this.id);
    console.log("asdfa");
    this.patientservice.GetMemberList(this.id).subscribe(data => {this.listData =new MatTableDataSource(data);
      this.listData.sort = this.sort;
      this.listData.paginator = this.paginator;});    
  }

  applyFilter(filtervalue : string)
  {
    this.listData.filter = filtervalue.trim().toLowerCase();
  }

  addNewRecord()  {
    const dialogconfig = new MatDialogConfig();
    dialogconfig.disableClose = false;
    dialogconfig.height = '50%';
    dialogconfig.width = '50%';
    dialogconfig.autoFocus = true;
    dialogconfig.data= {
      myvar : "",
      pagemode: "Add Mode",
    };
    this.dialog.open(NewmembersComponent,dialogconfig).afterClosed().subscribe(result =>{
//      if (result=="refresh")
        this.loadmemberlist();
    });
   }

  LoadOldRecord(row) {
    const dialogconfig = new MatDialogConfig();
    dialogconfig.disableClose = false;
    dialogconfig.height = '50%';
    dialogconfig.width = '50%';
    dialogconfig.autoFocus = true;
    dialogconfig.data= {
      myvar : row,
      pagemode: "Add Mode",
    };
    this.dialog.open(NewmembersComponent,dialogconfig).afterClosed().subscribe(result =>{
      //if (result=="refresh")
        this.loadmemberlist();
    });
  }
  
}
